import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { updateAttendant } from 'store/Attendants/actions'
import { CONVERT_TO_ORGANIZATION_ATTENDANT_MESSAGES } from 'resources'

const ConvertToOrgAttendant = ({ currentAttendant }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const onClickConvertOrg = () => {
    const updatePosAccountValues = {
      venueUuid: null,
      uuid: currentAttendant?.uuid,
      employeeId: currentAttendant?.employeeId,
    }

    dispatch(updateAttendant(updatePosAccountValues)).then(() => {
      history.push({ state: { posAccountUuid: null } })
    })
  }

  return (
    <section className="item-settings__section">
      {CONVERT_TO_ORGANIZATION_ATTENDANT_MESSAGES.map(
        (message, index) => (
          <span
            className="description padding-bottom-base"
            key={index}
          >
            {message}
          </span>
        )
      )}
      <button
        className="btn -outline"
        onClick={onClickConvertOrg}
        type="button"
      >
        Convert to Organization Attendant
      </button>
    </section>
  )
}

export default ConvertToOrgAttendant
